import AtcFlightSegmentDetailsFlight from './flight-segment-details-flight-component';

import './flight-segment-details-flight.scss';

const MODULE_NAME = 'app.atc.flight.segment.details.flight';
const module = angular.module(MODULE_NAME, [])
    .directive(AtcFlightSegmentDetailsFlight.DIRECTIVE_NAME, AtcFlightSegmentDetailsFlight);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-segment/flight-segment-details-flight/flight-segment-details-flight-module.js